import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MainLayout from '../components/MainLayout';
import { searchAPI } from '../api';
import { SearchResultRow, TYPE_META } from '../components/GlobalSearch';

// Full results view (Enter in the global search when there are multiple matches)
export default function SearchResults() {
  const [params] = useSearchParams();
  const q = (params.get('q') || '').trim();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setData(null); return; }
    setLoading(true);
    searchAPI.search(q, 50).then(r => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [q]);

  const groups = [['loads', 'Loads', 'load'], ['customers', 'Customers', 'customer'], ['carriers', 'Carriers', 'carrier'], ['facilities', 'Facilities', 'facility']];
  const total = groups.reduce((n, [k]) => n + (data?.[k]?.length || 0), 0);

  return (
    <MainLayout>
      <div className="p-4 md:p-6" data-testid="search-results-page">
        <h1 className="text-2xl md:text-3xl font-bold text-[var(--tms-text)]">Search results</h1>
        <p className="text-sm text-[var(--tms-text-secondary)] mt-1" data-testid="search-results-summary">
          {loading ? 'Searching…' : q ? `${total} match${total === 1 ? '' : 'es'} for "${q}"` : 'Type in the search bar above to search loads, customers, carriers and facilities.'}
        </p>
        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          {groups.map(([key, label, type]) => {
            const items = data?.[key] || [];
            if (!items.length) return null;
            const meta = TYPE_META[type];
            return (
              <div key={key} className="stats-card !p-0 overflow-hidden" data-testid={`search-results-group-${key}`}>
                <div className="flex items-center gap-2 px-4 py-3 border-b border-[var(--tms-border)]">
                  <meta.Icon className="w-4 h-4" style={{ color: meta.color }} />
                  <h2 className="font-semibold text-[var(--tms-text)]">{label}</h2>
                  <span className="text-xs text-[var(--tms-text-muted)]">{items.length}</span>
                </div>
                <div className="divide-y divide-[var(--tms-border)]">
                  {items.map(r => <SearchResultRow key={`${r.type}-${r.id}`} r={r} query={q} onClick={(x) => navigate(x.url)} testId={`search-result-${r.type}-${r.id}`} />)}
                </div>
              </div>
            );
          })}
        </div>
        {!loading && q && total === 0 && <p className="text-sm text-[var(--tms-text-muted)] mt-6">Nothing matched. Try a load #, PO #, BOL #, trailer #, carrier, MC #, customer, facility or city.</p>}
      </div>
    </MainLayout>
  );
}
